import { useSpring } from "react-spring"
import SVG from "react-inlinesvg"
import {
  Bed,
  Compass,
  EmptyButton
} from "../../../ApartmentFinderConfig/Icons/buttons/number/Icons"

import {
  BuildingDiagramContainer,
  BuildingDiagramLayout,
  ControlsStrip,
  FilterButtonContainer,
  FilterButtonsContainer,
  FilterButtonStrip,
  UI
} from "../../../ApartmentFinderConfig/FilteringUI.style"
import { bedrooms, aspect } from "../Utils/config/global"
import SvgJSX from "../Components/SvgJSX"

import { colours } from "../../../ApartmentFinderConfig/colours"
import { useStore } from "../../../state/store"

function FilteringUI({ show }) {
  const setCurrentCameraPositionID = useStore(state => state.setCurrentCameraPositionID)

  const setApartmentFinderActive = useStore(state => state.setApartmentFinderActive)
  const apartmentFinderActive = useStore(state => state.apartmentFinderActive)
  const activeBlock = useStore(state => state.activeBlock)
  const setActiveBlock = useStore(state => state.setActiveBlock)
  const setFavouritesActive = useStore(state => state.setFavouritesActive)

  const bedroomCounts = useStore(state => state.bedroomCounts)
  const resetBedCounts = useStore(state => state.resetBedCounts)

  const resetBathroomCounts = useStore(state => state.resetBedCounts)

  const toggleAspect = useStore(state => state.toggleAspect)
  const aspects = useStore(state => state.aspects)

  const toggleBedroomCounts = useStore(state => state.toggleBedroomCounts)
  const props = useSpring({
    left: apartmentFinderActive ? 10 : -900
  })
  const toggleFinder = () => {
    setActiveBlock(null)
    setFavouritesActive(false)

    setCurrentCameraPositionID(apartmentFinderActive ? "wide" : "site")
    setApartmentFinderActive(!apartmentFinderActive)
  }

  const clearBlockSelection = () => {
    setActiveBlock(null)
  }
  const refreshFilter = () => {
    resetBedCounts()
    resetBathroomCounts()
  }

  const buildingNames = {
    E: "Manuscript Court",
    K: "Fold House",
    F: "Dispatch House / Opus House",
    J: "Majesty House"
  }

  return (
    <>
      <div
        style={{
          cursor: "pointer",
          zIndex: 2000,
          position: "absolute",
          right: "0%",
          bottom: "0%",
          margin: "2vw",
          marginBottom: "1vw"
        }}
      >
        {activeBlock ? (
          <SVG
            style={{ cursor: "pointer" }}
            onClick={clearBlockSelection}
            src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/close-icon.svg`}
            width={75}
            height={75}
            title="Exit"
          />
        ) : (
          <SVG
            style={{ cursor: "pointer" }}
            onClick={() => toggleFinder()}
            src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/${
              apartmentFinderActive ? "toggleapoff" : "toggleapon"
            }.svg`}
            width={75}
            height={75}
            title="Exit"
          />
        )}
      </div>
      <UI style={props}>
        <FilterButtonsContainer>
          <FilterButtonStrip>
            <FilterButtonContainer>
              <Bed onClick={() => console.log("ss")} />
            </FilterButtonContainer>
            {bedrooms.map((_, i) => (
              <FilterButtonContainer
                onClick={() => {
                  toggleBedroomCounts(i)
                }}
                key={i}
              >
                <EmptyButton
                  text={i === 0 ? "St" : i}
                  backgroundColourOff={colours.primaryUI}
                  backgroundColourOn={colours.primaryUILight}
                  textColorOn={colours.primaryUILight}
                  textColorOff={colours.primaryUI}
                  isOn={bedroomCounts.includes(i)}
                />
              </FilterButtonContainer>
            ))}
          </FilterButtonStrip>
          <FilterButtonStrip>
            <FilterButtonContainer>
              <Compass />
            </FilterButtonContainer>
            {aspect.map((v, i) => (
              <FilterButtonContainer onClick={() => toggleAspect(v)} key={i}>
                <EmptyButton
                  text={aspect[i]}
                  backgroundColourOff={colours.primaryUI}
                  backgroundColourOn={colours.primaryUILight}
                  textColorOn={colours.primaryUILight}
                  textColorOff={colours.primaryUI}
                  isOn={aspects.includes(v)}
                />
              </FilterButtonContainer>
            ))}
          </FilterButtonStrip>
        </FilterButtonsContainer>
        <BuildingDiagramContainer>
          <SvgJSX activeBlock={activeBlock} />
        </BuildingDiagramContainer>
        <ControlsStrip>
          {activeBlock ? (
            <SVG
              style={{ cursor: "pointer" }}
              onClick={clearBlockSelection}
              src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/close-icon.svg`}
              width={50}
              height={50}
              title="Exit"
            />
          ) : (
            <SVG
              style={{ cursor: "pointer" }}
              onClick={() => toggleFinder()}
              src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/${
                apartmentFinderActive ? "toggleapoff" : "toggleapon"
              }.svg`}
              width={50}
              height={50}
              title="Menu"
            />
          )}
          {activeBlock ? buildingNames[activeBlock] : "EXPLORE"}
          <SVG
            style={{ cursor: "pointer" }}
            onClick={() => refreshFilter()}
            src={`${process.env.PUBLIC_URL}/assets/apartmentfinder/icons/refresh-icon.svg`}
            width={35}
            height={35}
            title="Menu"
          />
        </ControlsStrip>
      </UI>
    </>
  )
}

export default FilteringUI
